const platformAdmin = {
  app: {
    title: 'AIONA 横断管理',
    signOut: 'ログアウト',
    menuLabel: '管理メニュー',
    tenantsNav: 'テナント',
    auditLog: '操作履歴',
  },
  login: {
    prompt: 'Entra IDでログインしてください。',
    signIn: 'Entra IDでログイン',
  },
  environment: {
    label: '対象環境',
    loadingSettings: '環境設定を読み込み中…',
    readOnly: 'この環境は閲覧のみです。',
    demo: 'デモ',
    production: '本番',
    heading: '対象環境: {{environment}}',
    checkingAccess: '{{environment}}のアクセス権を確認中…',
  },
  common: {
    notVerified: '未確認',
    loadingOption: '読み込み中',
    status: '状態',
    expires: '期限',
    loading: '読み込み中…',
    operation: '操作',
    reason: '理由',
    reviewDetails: '内容を確認',
    cancel: 'キャンセル',
    none: 'なし',
  },
  lifecycle: {
    active: '本契約',
    trial: 'トライアル',
    suspended: '停止中',
    archived: 'アーカイブ',
  },
  usage: {
    fresh: '集計済み',
    stale: '集計が古いため利用件数は未確認です',
    unaggregated: '必要期間が未集計のため利用件数は未確認です',
    definition: '機能別件数: 直近7日の監査イベント。利用人数: 直近7日の重複なしユーザー数。ユーザー別件数: 直近30日。',
    summary: '{{status}} ／ 最終成功: {{completedAt}} ／ 集計対象末尾:  {{coveredUntil}}',
  },
  tenants: {
    title: 'テナント一覧',
    empty: 'テナントがありません。',
    name: 'テナント名',
    events7d: '直近7日の利用件数',
    eventCount: '{{events}}件',
  },
  detail: {
    contractSection: '契約・担当者',
    featureUsageTitle: '主要機能の利用（直近7日）',
    activeUsers: '利用ユーザー',
    recentActivity: '最近の動き',
    userUsageTitle: 'ユーザー別利用（直近30日・監査ログ）',
    user: 'ユーザー',
    userEventCount: '利用件数',
    savedDataTitle: '保存済みデータ',
    codeAndEnvironment: '{{code}} ／ 対象環境: {{environment}}',
    statusLine: '状態: {{status}} ／ 期限:  {{expires}}',
    owners: '担当者: {{owner}} {{separator}} CS: {{cs}} ／ 営業: {{sales}}',
    activeUsersCount: '{{users}}人',
    savedDataSummary: 'チャット{{threads}}スレッド ／ {{messages}}メッセージ ／ DRBFM {{drbfmSessions}}件',
  },
  features: {
    search: '検索',
    chat: 'チャット',
    drbfm: 'DRBFM',
    cad: 'CAD',
    upload: 'アップロード',
    failures: '失敗',
  },
  events: {
    empty: '記録がありません。',
    createdAt: '日時',
    result: '結果',
    admin: '管理者',
  },
  operations: {
    actions: {
      extendTrial: '期限延長',
      suspend: '停止',
      reactivate: '再開（本契約）',
      dataCleanup: '個別データ削除',
    },
    title: '管理操作',
    chatHistory: 'チャット履歴',
    cleanupNotice: 'アップロード文書は対象外です。削除は元に戻せません。',
    dialogLabel: '管理操作の確認',
    running: '実行中…',
    confirmTitle: '{{action}}の確認',
    targetLine: '対象環境: {{environment}} ／ テナント: {{tenant}} ({{code}})',
    reasonLine: '理由: {{reason}}',
    expiresLine: '期限: {{expires}}',
    deleteTargets: '削除対象: {{targets}}',
    runIn: '{{environment}}で実行',
  },
  trial: {
    title: '新規トライアル',
    companyName: '会社名',
    tenantCode: 'テナントコード',
    initialAdminEmail: '初期管理者メール',
    ownerEmail: '担当者メール',
    csOwnerEmail: 'CS担当メール',
    salesOwnerEmail: '営業担当メール',
    notes: 'メモ',
    dialogLabel: 'トライアル作成の確認',
    summary: '{{company}} ({{code}}) {{separator}} {{email}} ／ 期限:  {{expires}}',
    featuresLine: '機能: {{features}}',
    createIn: '{{environment}}で作成',
  },
  errors: {
    loadFailed: '読み込みに失敗しました。',
    microsoftSignInIncomplete: 'Microsoft認証が完了しませんでした。再度ログインしてください。',
    authNotVerified: '認証を確認できませんでした。再度ログインしてください。',
    entraNotConfigured: 'Entra IDの設定がありません。管理者に確認してください。',
    writesNotPermitted: 'この環境では変更操作が許可されていません。',
    invalidEnvironmentConfig: '管理APIの環境設定が不正です。',
    currentEnvironmentMissing: '現在の環境が設定されていません。',
    environmentMismatch: '選択環境と管理APIの環境が一致しません。',
    requestFailed: '管理APIにアクセスできません ({{status}})。選択環境の認証・権限・接続を確認してください。',
  },
};
export default platformAdmin;
